const handleZipCode = (event) => {
  let input = event.target;
  input.value = zipCodeMask(input.value);
};

const zipCodeMask = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{5})(\d)/, "$1-$2");
  return value;
};

const handleError = (hiddenClass, shownClass, errorText) => {
  handleLoader("shownLoader", "hiddenLoader");

  const errorSpan = document.querySelector(".hiddenError");

  if (errorSpan !== null) {
    errorSpan.classList.remove(hiddenClass);
    errorSpan.classList.add(shownClass);
    errorSpan.innerHTML = errorText;
  }
};

async function getCepData(cep) {
  const response = await fetch("https://viacep.com.br/ws/" + cep + "/json/");
  const data = await response.json();
  return data;
}

async function cartGetRates(country, state, zip) {
  return await fetch(
    "/cart/shipping_rates.json?" +
      new URLSearchParams({
        "shipping_address[country]": country,
        "shipping_address[province]": state,
        "shipping_address[zip]": zip,
      }).toString()
  )
    .then((response) => response.json())
    .catch(() => {
      handleError(
        "shownError",
        "hiddenError",
        "Erro ao calcular frete. Tente novamente mais tarde."
      );
    });
}

async function getCurrentProduct() {
  const url = `${window.location.pathname}.json`;

  const { product } = await fetch(url)
    .then((resp) => resp.json())
    .catch(() =>
      handleError(
        "shownError",
        "hiddenError",
        "Erro ao calcular frete. Tente novamente mais tarde."
      )
    );

  return product.variants[0].id;
}

async function mockCart(formData = {}) {
  if (Object.keys(formData).length !== 0) {
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .catch(() => {
        handleError(
          "hiddenError",
          "shownError",
          "Erro ao calcular frete. Tente novamente mais tarde."
        );
      });
  } else {
    await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch(() => {
        handleError(
          "hiddenError",
          "shownError",
          "Erro ao calcular frete. Tente novamente mais tarde."
        );
      });
  }
}

function clearTable(table) {
  if (table !== null) {
    table.classList.add("hiddenTable");
    table.innerHTML = "";
  }
}

function populateTable(shipping_rates, table) {
  if (table !== null) {
    table.innerHTML = `
    <tr>
      <th>Entrega</th>
      <th>Frete</th>
      <th>Prazo</th>
    </tr>
    `;

    table.classList.remove("hiddenTable");

    if (shipping_rates.length === 0) {
      const newTR = document.createElement("tr");

      const html = `
          <td>Frete não disponível</td>
        `;

      newTR.innerHTML = html;

      table.appendChild(newTR);
    } else {
      shipping_rates.forEach((element) => {
        const newTR = document.createElement("tr");

        const brPrice = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(element.price);

        const prazo = (() => {
          if (!element.delivery_date) return "Consultar prazo";
          const pascoa = (y) => {
            const a = y % 19, b = Math.floor(y / 100), c = y % 100;
            const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
            const m = Math.floor((a + 11 * h + 22 * l) / 451);
            const mes = Math.floor((h + l - 7 * m + 114) / 31);
            const dia = ((h + l - 7 * m + 114) % 31) + 1;
            return new Date(y, mes - 1, dia);
          };
          const feriado = (dt) => {
            const md = String(dt.getMonth() + 1).padStart(2, "0") + "-" + String(dt.getDate()).padStart(2, "0");
            if (["01-01", "04-21", "05-01", "09-07", "10-12", "11-02", "11-15", "11-20", "12-25"].includes(md)) return true;
            const sextaSanta = pascoa(dt.getFullYear());
            sextaSanta.setDate(sextaSanta.getDate() - 2);
            return dt.toDateString() === sextaSanta.toDateString();
          };
          const [y, mo, da] = element.delivery_date.split("-").map(Number);
          const fim = new Date(y, mo - 1, da);
          const dt = new Date();
          dt.setHours(0, 0, 0, 0);
          let dias = 0;
          while (dt < fim) {
            dt.setDate(dt.getDate() + 1);
            if (dt.getDay() !== 0 && dt.getDay() !== 6 && !feriado(dt)) dias++;
          }
          if (dias < 1) dias = 1;
          return dias === 1 ? "1 dia útil" : dias + " dias úteis";
        })();
        const html = `
            <td>${element.presentment_name}</td>
            <td>${brPrice}</td>
            <td>${prazo}</td>
          `;
        newTR.innerHTML = html;

        table.appendChild(newTR);
      });
    }
  }
}

function handleLoader(removedClass, shownClass) {
  const loader = document.querySelector(".loader");

  if (loader !== null) {
    loader.classList.remove(removedClass);
    loader.classList.add(shownClass);
  }
}

async function submitZipForm(zip, table) {
  handleLoader("hiddenLoader", "shownLoader");
  const productId = await getCurrentProduct();

  await mockCart({
    id: productId,
    quantity: 1,
  });

  const { uf } = await getCepData(zip);

  const { shipping_rates } = await cartGetRates("Brazil", uf, zip);

  handleLoader("shownLoader", "hiddenLoader");
  populateTable(shipping_rates, table);

  await mockCart();
}

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("zip-code-input");
  const table = document.querySelector(".zipTable");
  const form = document.querySelector(".zipForm");

  if (input !== null) {
    input.addEventListener("keyup", (e) => {
      handleZipCode(e);

      if (input.value === "") {
        handleError("hiddenError", "shownError", "");
      }
    });
  }

  if (form !== null) {
    const button = form.querySelector("button");

    if (button !== null) {
      button.addEventListener("click", async () => {
        clearTable(table);

        input.value.length !== 9
          ? handleError("hiddenError", "shownError", "Insira um CEP valido.")
          : await submitZipForm(input.value, table);
      });
    }
  }
});
